import {
  EVENT_TYPE_PHA,
  EVENT_TYPE_PHA_FLY,
  EVENT_TYPE_OHE,
  EVENT_TYPE_SHPE,
  EVENT_TYPE_AUDIOGRAM,
  EVENT_TYPE_LAB,
  EVENT_TYPE_SECURITY_FORCES_PCM,
  EVENT_TYPE_CMR,
  EVENT_TYPE_CMR_FLY,
} from '../../../constants/eventTypes';

const optionFromLabel = (label) => ({
  id: label,
  label,
});

const optionsFromLabels = (labels) => labels.map(optionFromLabel);

export const REJECT_REASON_ANY_OPTION_ID = '__ANY_REASON__';
export const REJECT_REASON_ANY_OPTION_VALUE = null;
export const REJECT_REASON_OTHER_OPTION_ID = '__OTHER_REASON__';
export const OTHER_REASON_MAX_LENGTH = 50;

const EVENT_TYPE_REJECT_REASON_OPTIONS = {
  [EVENT_TYPE_PHA_FLY]: optionsFromLabels(['Incomplete PHAQ']),
  [EVENT_TYPE_PHA]: optionsFromLabels(['Incomplete PHAQ']),
  [EVENT_TYPE_OHE]: optionsFromLabels([
    'Incomplete Checklist',
    'Requirements not complete 90 days before Exam',
  ]),
  [EVENT_TYPE_SHPE]: optionsFromLabels(['Incomplete Questionnaire', 'Incomplete Audiogram']),
  [EVENT_TYPE_AUDIOGRAM]: optionsFromLabels(['Audiogram Not Required']),
  [EVENT_TYPE_LAB]: optionsFromLabels(['No Current Orders', 'Unforeseen Closure']),
  [EVENT_TYPE_SECURITY_FORCES_PCM]: optionsFromLabels(['Not SF Member', 'Wrong PCM']),
  [EVENT_TYPE_CMR]: optionsFromLabels([
    'No Appointments Available',
    'Dental Due Date',
    'All GREEN',
    'Sister Services',
    'Not on AD Orders',
  ]),
  [EVENT_TYPE_CMR_FLY]: optionsFromLabels([
    'No Appointments Available',
    'Dental Due Date',
    'All GREEN',
    'Sister Services',
    'Not on AD Orders',
  ]),
};

const SHARED_REJECT_REASON_OPTIONS = [optionFromLabel('Schedule Conflict')];

const DEFAULT_REJECT_REASON_OPTIONS = [
  ...SHARED_REJECT_REASON_OPTIONS,
  { id: REJECT_REASON_OTHER_OPTION_ID, label: 'Other' },
];

export const getRejectReasonOptions = (eventType) => {
  return [...(EVENT_TYPE_REJECT_REASON_OPTIONS[eventType] || []), ...DEFAULT_REJECT_REASON_OPTIONS];
};

export const getSchedulerNotificationReasonOptions = (eventType) => {
  return [
    { id: REJECT_REASON_ANY_OPTION_ID, label: 'Any reason' },
    ...(EVENT_TYPE_REJECT_REASON_OPTIONS[eventType] || []),
    ...SHARED_REJECT_REASON_OPTIONS,
  ];
};

export const isOtherRejectReasonOption = (optionId) => {
  return optionId === REJECT_REASON_OTHER_OPTION_ID;
};
